// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2dT26","errors":"Errors_errors__1l7O9"};